// Panel dédié Hermes — pattern network (1 fichier fin par CLI).
import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { CliPanel } from "./cli/cli-panel";

const HermesCliPanel: Component = () => <CliPanel cli="hermes" />;

registerPanel("cli-hermes", HermesCliPanel);
export default HermesCliPanel;
